import { render, staticRenderFns } from "./novel.vue?vue&type=template&id=0b5208f9&scoped=true"
import script from "./novel.vue?vue&type=script&lang=js"
export * from "./novel.vue?vue&type=script&lang=js"
import style0 from "./novel.vue?vue&type=style&index=0&id=0b5208f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5208f9",
  null
  
)

export default component.exports